import update from 'react-addons-update';
import {
  COMPANYINFO_SEL,
  STAFF_CHECK_ADD,
  STAFF_LINK_ADD,
  STAFFSIGNUP_STATUS_SEL,
  STAFF_REQUESTED_SEL,
  STAFF_RESEND_SEL,
  STAFF_BULK_MOD,
  STAFF_ACT,
  STAFF_DEL,
  STAFF_PWD_CHANGE,
  STAFF_EXCEL_CHECK,
  STAFF_EXCEL_UPLOAD,
  POSITION_SEL,
  POSITION_ADD,
  POSITION_MOD,
  POSITION_DEL,
  DIVISION_SORT_MOD,
  DIVISION_ADD,
  DIVISION_DEL,
  DIVISION_USER_COUNT,
  DIVISION_BUDGET,
  DIVISION_ADD_BUDGET,
  DIVISION_MOD_BUDGET,
  DIVISION_DEL_BUDGET,
  DIVISION_SEL_BUDGET,
  NOTICE_LIST,
  NOTICE_ADD,
  NOTICE_SEL,
  NOTICE_MOD,
  PUSH_LIST,
  PUSH_ADD,
  LOG_OUT,
  LOG_OUT_STEP_TWO,
  CHANGE_INFO_SEL,
  CANCEL_RESERVE,
  LOGIN_HISTORY
} from 'actions/company';

import {
  CAPTAIN_DIVISION_ADD,
  CAPTAIN_DIVISION_MOD,
  CAPTAIN_DIVISION_USER_COUNT,
  CAPTAIN_PAYMENT_NOTICE_LIST,
  CAPTAIN_PAYMENT_NOTICE_SEL,
  CAPTAIN_PAYMENT_NOTICE_ADD,
  CAPTAIN_PAYMENT_NOTICE_MOD,
  CAPTAIN_PAYMENT_PUSH_LIST,
  CAPTAIN_PAYMENT_PUSH_ADD
} from '../actions/captainPayment';

let userCnt = [];

function company(state = {}, action) {
  const { payload } = action;

  switch (action.type) {
    case `${COMPANYINFO_SEL}_FULFILLED`:
      return {
        ...state,
        info: payload
      };
    case `${COMPANYINFO_SEL}_PENDING`:
      return {
        ...state,
        info: payload
      };
    case `${COMPANYINFO_SEL}_REJECTED`:
      return {
        ...state,
        info: payload
      };

    case `${STAFF_CHECK_ADD}_FULFILLED`:
      return {
        ...state,
        check: payload
      };
    case `${STAFF_CHECK_ADD}_PENDING`:
      return {
        ...state,
        check: payload
      };
    case `${STAFF_CHECK_ADD}_REJECTED`:
      return {
        ...state,
        check: payload
      };

    case `${STAFF_LINK_ADD}_FULFILLED`:
      return {
        ...state,
        link: payload
      };
    case `${STAFF_LINK_ADD}_PENDING`:
      return {
        ...state,
        link: payload
      };
    case `${STAFF_LINK_ADD}_REJECTED`:
      return {
        ...state,
        link: payload
      };

    case `${STAFFSIGNUP_STATUS_SEL}_FULFILLED`:
      return {
        ...state,
        data: payload
      };
    case `${STAFFSIGNUP_STATUS_SEL}_PENDING`:
      return {
        ...state,
        data: payload
      };
    case `${STAFFSIGNUP_STATUS_SEL}_REJECTED`:
      return {
        ...state,
        data: payload
      };

    case `${STAFF_REQUESTED_SEL}_FULFILLED`:
      return {
        ...state,
        requested: payload
      };
    case `${STAFF_REQUESTED_SEL}_PENDING`:
      return {
        ...state,
        requested: payload
      };
    case `${STAFF_REQUESTED_SEL}_REJECTED`:
      return {
        ...state,
        requested: payload
      };

    case `${STAFF_RESEND_SEL}_FULFILLED`:
      return {
        ...state,
        resend: payload
      };
    case `${STAFF_RESEND_SEL}_PENDING`:
      return {
        ...state,
        resend: payload
      };
    case `${STAFF_RESEND_SEL}_REJECTED`:
      return {
        ...state,
        resend: payload
      };

    case `${STAFF_ACT}_FULFILLED`:
      return {
        ...state,
        staff_act: payload
      };

    case `${STAFF_ACT}_PENDING`:
      return {
        ...state,
        staff_act: payload
      };

    case `${STAFF_ACT}_REJECTED`:
      return {
        ...state,
        staff_act: payload
      };

    case `${STAFF_DEL}_FULFILLED`:
      return {
        ...state,
        staffDel: payload
      };

    case `${STAFF_DEL}_PENDING`:
      return {
        ...state,
        staffDel: payload
      };

    case `${STAFF_DEL}_REJECTED`:
      return {
        ...state,
        staffDel: payload
      };

    case `${STAFF_PWD_CHANGE}_FULFILLED`:
      return {
        ...state,
        staff_pwd_change: payload
      };

    case `${STAFF_PWD_CHANGE}_PENDING`:
      return {
        ...state,
        staff_pwd_change: payload
      };

    case `${STAFF_PWD_CHANGE}_REJECTED`:
      return {
        ...state,
        staff_pwd_change: payload
      };

    case `${STAFF_EXCEL_CHECK}_FULFILLED`:
      return {
        ...state,
        staff_excel_check: payload
      };

    case `${STAFF_EXCEL_CHECK}_PENDING`:
      return {
        ...state,
        staff_excel_check: payload
      };

    case `${STAFF_EXCEL_CHECK}_REJECTED`:
      return {
        ...state,
        staff_excel_check: payload
      };

    case `${STAFF_EXCEL_UPLOAD}_FULFILLED`:
      return {
        ...state,
        staff_excel_upload: payload
      };

    case `${STAFF_EXCEL_UPLOAD}_PENDING`:
      return {
        ...state,
        staff_excel_upload: payload
      };

    case `${STAFF_EXCEL_UPLOAD}_REJECTED`:
      return {
        ...state,
        staff_excel_upload: payload
      };

    case `${POSITION_SEL}_FULFILLED`:
      return {
        ...state,
        position: payload
      };
    case `${POSITION_SEL}_PENDING`:
      return {
        ...state,
        position: payload
      };
    case `${POSITION_SEL}_REJECTED`:
      return {
        ...state,
        position: payload
      };

    case `${POSITION_ADD}_FULFILLED`:
      return {
        ...state,
        position_add_result: payload
      };

    case `${POSITION_ADD}_PENDING`:
      return {
        ...state,
        position_add_result: payload
      };

    case `${POSITION_ADD}_REJECTED`:
      return {
        ...state,
        position_add_result: payload
      };

    case `${POSITION_MOD}_FULFILLED`:
      return {
        ...state,
        position_mod_reault: payload
      };

    case `${POSITION_MOD}_PENDING`:
      return {
        ...state,
        position_mod_reault: payload
      };

    case `${POSITION_MOD}_REJECTED`:
      return {
        ...state,
        position_mod_reault: payload
      };

    case `${POSITION_DEL}_FULFILLED`:
      return {
        ...state,
        position_del_result: payload
      };

    case `${POSITION_DEL}_PENDING`:
      return {
        ...state,
        position_del_result: payload
      };

    case `${POSITION_DEL}_REJECTED`:
      return {
        ...state,
        position_del_result: payload
      };

    case `${DIVISION_ADD_BUDGET}_FULFILLED`:
      return {
        ...state,
        budget_add_data: payload
      };

    case `${DIVISION_ADD_BUDGET}_PENDING`:
      return {
        ...state,
        budget_add_data: payload
      };

    case `${DIVISION_ADD_BUDGET}_REJECTED`:
      return {
        ...state,
        budget_add_data: payload
      };

    case `${DIVISION_MOD_BUDGET}_FULFILLED`:
      return {
        ...state,
        budget_mod_data: payload
      };

    case `${DIVISION_MOD_BUDGET}_PENDING`:
      return {
        ...state,
        budget_mod_data: payload
      };

    case `${DIVISION_MOD_BUDGET}_REJECTED`:
      return {
        ...state,
        budget_mod_data: payload
      };

    case `${DIVISION_DEL_BUDGET}_FULFILLED`:
      return {
        ...state,
        budget_del_data: payload
      };

    case `${DIVISION_DEL_BUDGET}_PENDING`:
      return {
        ...state,
        budget_del_data: payload
      };

    case `${DIVISION_DEL_BUDGET}_REJECTED`:
      return {
        ...state,
        budget_del_data: payload
      };

    case `${DIVISION_SEL_BUDGET}_FULFILLED`:
      return {
        ...state,
        budget_sel_data: payload
      };

    case `${DIVISION_SEL_BUDGET}_PENDING`:
      return {
        ...state,
        budget_sel_data: payload
      };

    case `${DIVISION_SEL_BUDGET}_REJECTED`:
      return {
        ...state,
        budget_sel_data: payload
      };

    case `${DIVISION_BUDGET}_FULFILLED`:
      return {
        ...state,
        budget_data: payload
      };

    case `${DIVISION_BUDGET}_PENDING`:
      return {
        ...state,
        budget_data: payload
      };

    case `${DIVISION_BUDGET}_REJECTED`:
      return {
        ...state,
        budget_data: payload
      };

    case `${DIVISION_DEL}_FULFILLED`:
      return {
        ...state,
        division_del_result: payload
      };

    case `${DIVISION_ADD}_FULFILLED`:
      return {
        ...state,
        division_add_result: payload
      };

    case `${DIVISION_ADD}_PENDING`:
      return {
        ...state,
        division_add_result: payload
      };

    case `${DIVISION_ADD}_REJECTED`:
      return {
        ...state,
        division_add_result: payload
      };

    case `${DIVISION_DEL}_PENDING`:
      return {
        ...state,
        division_del_result: payload
      };

    case `${DIVISION_DEL}_REJECTED`:
      return {
        ...state,
        division_del_result: payload
      };

    case `${DIVISION_SORT_MOD}_FULFILLED`:
      return {
        ...state,
        division_sort_result: payload
      };

    case `${DIVISION_SORT_MOD}_PENDING`:
      return {
        ...state,
        division_sort_result: payload
      };

    case `${DIVISION_SORT_MOD}_REJECTED`:
      return {
        ...state,
        division_sort_result: payload
      };

    case `${NOTICE_LIST}_FULFILLED`:
      return {
        ...state,
        notice: payload
      };
    case `${NOTICE_LIST}_PENDING`:
      return {
        ...state,
        notice: payload
      };
    case `${NOTICE_LIST}_REJECTED`:
      return {
        ...state,
        notice: payload
      };

    case `${NOTICE_ADD}_FULFILLED`:
      return {
        ...state,
        result: payload
      };
    case `${NOTICE_ADD}_PENDING`:
      return {
        ...state,
        result: payload
      };
    case `${NOTICE_ADD}_REJECTED`:
      return {
        ...state,
        result: payload
      };

    case `${NOTICE_SEL}_FULFILLED`:
      return {
        ...state,
        detail: payload
      };
    case `${NOTICE_SEL}_PENDING`:
      return {
        ...state,
        detail: payload
      };
    case `${NOTICE_SEL}_REJECTED`:
      return {
        ...state,
        detail: payload
      };

    case `${NOTICE_MOD}_FULFILLED`:
      return {
        ...state,
        result: payload
      };
    case `${NOTICE_MOD}_PENDING`:
      return {
        ...state,
        result: payload
      };
    case `${NOTICE_MOD}_REJECTED`:
      return {
        ...state,
        result: payload
      };

    case `${PUSH_LIST}_FULFILLED`:
      return {
        ...state,
        list: payload
      };
    case `${PUSH_LIST}_PENDING`:
      return {
        ...state,
        list: payload
      };
    case `${PUSH_LIST}_REJECTED`:
      return {
        ...state,
        list: payload
      };

    case `${PUSH_ADD}_FULFILLED`:
      return {
        ...state,
        add: payload
      };
    case `${PUSH_ADD}_PENDING`:
      return {
        ...state,
        add: payload
      };
    case `${PUSH_ADD}_REJECTED`:
      return {
        ...state,
        add: payload
      };

    case `${STAFF_BULK_MOD}_FULFILLED`:
      return {
        ...state,
        bulkModResult: payload
      };

    case `${STAFF_BULK_MOD}_PENDING`:
      return {
        ...state,
        bulkModResult: payload
      };

    case `${STAFF_BULK_MOD}_REJECTED`:
      return {
        ...state,
        bulkModResult: payload
      };

    case `${DIVISION_USER_COUNT}_FULFILLED`:
      const { params } = payload.config;
      let isTurn = true;

      if (payload.data && payload.data.divisionUsers) {
        const { divisionUsers } = payload.data;
        userCnt.some((item) => {
          if (item.orgCode === divisionUsers[0].orgCode) {
            isTurn = false;
            return true;
          }
        });
        if (isTurn) {
          userCnt = update(userCnt, { $push: payload.data.divisionUsers });
        }
      }
      return {
        ...state,
        divisionUserCnt: userCnt
      };

    case `${DIVISION_USER_COUNT}_PENDING`:
      return {
        ...state,
        divisionUserCnt: payload
      };

    case `${DIVISION_USER_COUNT}_REJECTED`:
      return {
        ...state,
        divisionUserCnt: payload
      };

    case `${LOG_OUT}_FULFILLED`:
      return {
        ...state,
        logout: payload
      };

    case `${LOG_OUT}_PENDING`:
      return {
        ...state,
        logout: payload
      };

    case `${LOG_OUT}_REJECTED`:
      return {
        ...state,
        logout: payload
      };
    case `${LOG_OUT_STEP_TWO}_FULFILLED`:
      return {
        ...state,
        logoutStepTwo: payload
      };

    case `${LOG_OUT_STEP_TWO}_PENDING`:
      return {
        ...state,
        logoutStepTwo: payload
      };

    case `${LOG_OUT_STEP_TWO}_REJECTED`:
      return {
        ...state,
        logoutStepTwo: payload
      };

    case `${CHANGE_INFO_SEL}_FULFILLED`:
      return {
        ...state,
        changeInfoList: payload
      };

    case `${CHANGE_INFO_SEL}_PENDING`:
      return {
        ...state,
        changeInfoList: payload
      };

    case `${CHANGE_INFO_SEL}_REJECTED`:
      return {
        ...state,
        changeInfoList: payload
      };

    case `${CANCEL_RESERVE}_FULFILLED`:
      return {
        ...state,
        cancelReserve: payload
      };

    case `${CANCEL_RESERVE}_PENDING`:
      return {
        ...state,
        cancelReserve: payload
      };

    case `${CANCEL_RESERVE}_REJECTED`:
      return {
        ...state,
        cancelReserve: payload
      };

    case `${LOGIN_HISTORY}_FULFILLED`:
      return {
        ...state,
        loginHistory: payload
      };

    case `${LOGIN_HISTORY}_PENDING`:
      return {
        ...state,
        loginHistory: payload
      };

    case `${LOGIN_HISTORY}_REJECTED`:
      return {
        ...state,
        loginHistory: payload
      };

    case `${CAPTAIN_DIVISION_ADD}_FULFILLED`:
      // 대장마켓플레이스 임시
      return {
        ...state,
        division_add_result: payload
      };
    case `${CAPTAIN_DIVISION_ADD}_PENDING`:
      return {
        ...state,
        division_add_result: payload
      };
    case `${CAPTAIN_DIVISION_ADD}_REJECTED`:
      return {
        ...state,
        division_add_result: payload
      };

    case `${CAPTAIN_DIVISION_MOD}_FULFILLED`:
      // 대장마켓플레이스 임시
      return {
        ...state,
        division_sort_result: payload
      };
    case `${CAPTAIN_DIVISION_MOD}_PENDING`:
      return {
        ...state,
        division_sort_result: payload
      };
    case `${CAPTAIN_DIVISION_MOD}_REJECTED`:
      return {
        ...state,
        division_sort_result: payload
      };

    case `${CAPTAIN_DIVISION_USER_COUNT}_FULFILLED`:
      let isTurn2 = true;

      if (payload && payload.divisionUsers) {
        const { divisionUsers } = payload;
        userCnt.some((item) => {
          if (item.orgCode === divisionUsers[0].orgCode) {
            isTurn2 = false;
            return true;
          }
        });
        if (isTurn2) {
          userCnt = update(userCnt, { $push: payload.divisionUsers });
        }
      }
      return {
        ...state,
        divisionUserCnt: userCnt
      };

    case `${CAPTAIN_DIVISION_USER_COUNT}_PENDING`:
      return {
        ...state,
        divisionUserCnt: payload
      };

    case `${CAPTAIN_DIVISION_USER_COUNT}_REJECTED`:
      return {
        ...state,
        divisionUserCnt: payload
      };


      // CAPTAIN PAYMENT 임시
    case `${CAPTAIN_PAYMENT_NOTICE_LIST}_FULFILLED`:
      return {
        ...state,
        notice: payload
      };
    case `${CAPTAIN_PAYMENT_NOTICE_LIST}_PENDING`:
      return {
        ...state,
        notice: payload
      };
    case `${CAPTAIN_PAYMENT_NOTICE_LIST}_REJECTED`:
      return {
        ...state,
        notice: payload
      };

    case `${CAPTAIN_PAYMENT_NOTICE_ADD}_FULFILLED`:
      return {
        ...state,
        result: payload
      };
    case `${CAPTAIN_PAYMENT_NOTICE_ADD}_PENDING`:
      return {
        ...state,
        result: payload
      };
    case `${CAPTAIN_PAYMENT_NOTICE_ADD}_REJECTED`:
      return {
        ...state,
        result: payload
      };

    case `${CAPTAIN_PAYMENT_NOTICE_SEL}_FULFILLED`:
      return {
        ...state,
        detail: payload
      };
    case `${CAPTAIN_PAYMENT_NOTICE_SEL}_PENDING`:
      return {
        ...state,
        detail: payload
      };
    case `${CAPTAIN_PAYMENT_NOTICE_SEL}_REJECTED`:
      return {
        ...state,
        detail: payload
      };

    case `${CAPTAIN_PAYMENT_NOTICE_MOD}_FULFILLED`:
      return {
        ...state,
        result: payload
      };
    case `${CAPTAIN_PAYMENT_NOTICE_MOD}_PENDING`:
      return {
        ...state,
        result: payload
      };
    case `${CAPTAIN_PAYMENT_NOTICE_MOD}_REJECTED`:
      return {
        ...state,
        result: payload
      };

    case `${CAPTAIN_PAYMENT_PUSH_LIST}_FULFILLED`:
      return {
        ...state,
        list: { data: payload }
      };
    case `${CAPTAIN_PAYMENT_PUSH_LIST}_PENDING`:
      return {
        ...state,
        list: payload
      };
    case `${CAPTAIN_PAYMENT_PUSH_LIST}_REJECTED`:
      return {
        ...state,
        list: payload
      };

    case `${CAPTAIN_PAYMENT_PUSH_ADD}_FULFILLED`:
      return {
        ...state,
        add: payload
      };
    case `${CAPTAIN_PAYMENT_PUSH_ADD}_PENDING`:
      return {
        ...state,
        add: payload
      };
    case `${CAPTAIN_PAYMENT_PUSH_ADD}_REJECTED`:
      return {
        ...state,
        add: payload
      };

    default:
      return state;
  }
}

export default company;
